import React, { Component } from 'react'
import { compose } from 'react-apollo'
import { injectGlobal } from 'styled-components'
import { Switch, Route, Redirect, withRouter } from 'react-router'
import { ThemeProvider } from 'styled-components'
import { injectLayoutBaseCSS, GridThemeProvider } from 'styled-bootstrap-grid'
import getRelativeUrl from 'utils/getRelativeUrl'

import MediaProvider from 'redux/modules/media/MediaProvider'
import withSiteMeta from 'containers/withSiteMeta'
import withRedirects from 'containers/withRedirects'
import theme from 'ui/styles/theme'
import global from 'ui/styles/global'
import GridView from 'ui/components/generic/GridView';
import AnimatedRoutes from 'ui/components/AnimatedRoutes';
import Navigation from 'ui/components/Navigation';
import Footer from 'ui/components/Footer';
import Page from 'ui/components/Page';
import Loading from 'ui/components/generic/Loading';
import Popup from 'ui/components/Popup';
import GoogleManager from './ui/components/GTM/GoogleManager'

class App extends Component {
  render() {

    // Apply bootstrap global styling
    injectLayoutBaseCSS()

    // Apply custom global styling
    injectGlobal`${global}`

    const {
      location,
      match,
      siteMetaLoading,
      siteMeta,
      redirects,
      redirectsLoading
    } = this.props

    if (siteMetaLoading || redirectsLoading) {
      return <Loading />
    }

    return (
      <div className={siteMeta && siteMeta.rtlActive ? 'text-rtl' : null}>
        <ThemeProvider theme={theme}>
          <GridThemeProvider gridTheme={theme.grid}>
            <MediaProvider>
              <Navigation />
              <AnimatedRoutes pathname={location.pathname}>
                <Switch location={location}>
                  {redirects.map(({ from, to }) => (
                    <Redirect
                      key={from}
                      exact
                      from={from}
                      to={getRelativeUrl(to)}
                    />
                  ))}
                  
                  <Route
                    exact
                    path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/`}
                    render={props =>
                      <Page type="page" key={match.url} {...props} />
                    }
                  />
                  
                  <Route
                    exact
                    path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/:slug`}
                    render={props =>
                      <Page type="page" key={match.url} {...props} />
                    }
                  />
                  
                  <Route
                    exact
                    path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/cases/:slug`}
                    render={props =>
                      <Page type="case" key={match.url} {...props} />
                    }
                  />
                  
                  <Route
                    exact
                    path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/products/:slug`}
                    render={props =>
                      <Page type="product" key={match.url} {...props} />
                    }
                  />

<Route
                    exact
                    path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/documents/:slug`}
                    render={props =>
                      <Page type="document" key={match.url} {...props} />
                    }
                  />
                  
                  <Route
                    exact
                    path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/:parent/:slug`}
                    render={props =>
                      <Page type="page" key={match.url} {...props} />
                    }
                  />
                
                </Switch>
              </AnimatedRoutes>
              <GoogleManager/>
              <Popup />
              <Footer />
              { process.env.NODE_ENV === 'development' && <GridView /> }
            </MediaProvider>
          </GridThemeProvider>
        </ThemeProvider>
      </div>
    );
  }
}

export default compose(
  withSiteMeta(),
  withRedirects(),
  withRouter
)(App)



// WEBPACK FOOTER //
// ./src/App.js